import { fromJS } from 'immutable';

const ENDPOINT = '/api/dwellings';

const ACTIVITIES_INIT = 'dwellings/ACTIVITIES_INIT';
const ACTIVITIES_SUCCESS = 'dwellings/ACTIVITIES_SUCCESS';
const ACTIVITIES_FAILED = 'dwellings/ACTIVITIES_FAILED';

const AUDIT_INIT = 'dwellings/AUDIT_INIT';
const AUDIT_SUCCESS = 'dwellings/AUDIT_SUCCESS';
const AUDIT_FAILED = 'dwellings/AUDIT_FAILED';

const initialState = fromJS({
  uuid: null,
  data: null,
  activities: null,
  timestamp: null,
  loading: false
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ACTIVITIES_INIT:
      return state.merge({
        activities: initialState.get('activities'),
        loading: true
      });
    case ACTIVITIES_SUCCESS:
      return state.merge({ activities: action.payload, loading: false });
    case ACTIVITIES_FAILED:
      return state.merge({
        activities: initialState.get('activities'),
        loading: false
      });
    default:
      return state;
  }
}

export function activities(uuid) {
  return {
    types: [ACTIVITIES_INIT, ACTIVITIES_SUCCESS, ACTIVITIES_FAILED],
    promise: client => client.get(`${ENDPOINT}/${uuid}/audit`).then(rejectNonOK)
  };
}

export function audit(uuid, reason) {
  return {
    types: [AUDIT_INIT, AUDIT_SUCCESS, AUDIT_FAILED],
    promise: client =>
      client
        .post(`${ENDPOINT}/${uuid}/audit`, {
          data: { action: 'notes', reason }
        })
        .then(rejectNonOK)
  };
}

function rejectNonOK({ status, result, results }) {
  if (status !== 'OK') {
    throw new Error('Fetch request failed');
  }
  return result || results;
}
